import React, { Component } from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { withRouter } from 'react-router-dom';

import { GET_FABRIC_DATA } from 'mocks/queries';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { Helmet } from 'react-helmet-async';
import { INSPIRATION_PAGE_SEO_DESCRIPTION } from 'commons/constants';
import withApolloSuspenseQuery from 'components/hoc/withApolloSuspenseQuery';
import { withSearchState } from './search-state/withSearchState';
import InspirationPage from './inspiration-page';

const mobileItemsPerRowOptions = [1, 2, 3];

class InspirationPhotoGrid extends Component {
  state = {
    productSearchQuery: '',
    productSearchState: {
      query: '',
      configure: {
        facetFilters: '',
        facets: '*',
      },
      hitsPerPage: 24,
      page: 1,
    },
    fabricsData: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!!nextProps.getFabrics && !prevState.fabricsData) {
      return {
        fabricsData: nextProps.getFabrics.getFabrics,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filterState.isMaterialOptionFiltered &&
      !this.props.filterState.isMaterialOptionFiltered
    ) {
      this.resetProductSearch();
    }
  }

  resetProductSearch = () => {
    const updatedQuery = { ...this.state.productSearchState };
    updatedQuery.query = '';
    this.setState(() => ({
      productSearchState: updatedQuery,
    }));
  };

  onSearchUpdate = searchMode => {
    this.setState({
      productSearchState: searchMode,
    });
    if (
      !searchMode.query.length &&
      this.props.filterState.isProductIdFiltered.isFiltered
    ) {
      this.props.filterActions.onProductIdFilterChange('');
    }
  };

  toggleMobileItemsPerRow = () => {
    this.setState(prevState => {
      const options = mobileItemsPerRowOptions;
      const indexOfPrev = options.indexOf(prevState.mobileItemsPerRow);
      return {
        mobileItemsPerRow:
          indexOfPrev < options.length - 1
            ? options[indexOfPrev + 1]
            : options[0],
      };
    });
  };

  render() {
    const { state, actions, filterActions, filterState } = this.props;

    return (
      <>
        <Helmet>
          <title>Customer Photos | Joybird</title>
          <meta name="description" content={INSPIRATION_PAGE_SEO_DESCRIPTION} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Customer Photos by Joybird.com" />

          <meta
            property="og:description"
            content={INSPIRATION_PAGE_SEO_DESCRIPTION}
          />

          <meta
            property="og:url"
            content="https://joybird.com/customer-photos/"
          />

          <meta
            property="og:image"
            content="https://joybird2.imgix.net/meta/jb0916-FacebookPageThumbnails-CustomerGallery-v1.jpg?auto=compress,format"
          />
        </Helmet>

        <InstantSearch
          searchClient={searchClient}
          searchState={state.searchState}
          onSearchStateChange={actions.onSearchStateChange}
          indexName={state.mainIndex}
        >
          <Configure
            hitsPerPage={state.searchState.hitsPerPage}
            facets={state.searchState.configure.facets}
            facetFilters={state.searchState.configure.facetFilters}
          />

          <InspirationPage
            filterState={filterState}
            filterActions={filterActions}
            onSearchUpdate={this.onSearchUpdate}
            resetProductSearch={this.resetProductSearch}
            onLoadMoreResults={actions.onLoadMoreResults}
            mobileItemsPerRow={this.state.mobileItemsPerRow}
            productSearchQuery={this.state.productSearchQuery}
            productSearchState={this.state.productSearchState}
            toggleMobileItemsPerRow={this.toggleMobileItemsPerRow}
            toggleProductSearchResults={this.toggleSearch}
            fabricsData={this.state.fabricsData}
            LUXContext={this.props.LUXContext || null}
          />
        </InstantSearch>
      </>
    );
  }
}

InspirationPhotoGrid.propTypes = {
  state: PropTypes.shape({
    searchState: PropTypes.object,
    mainIndex: PropTypes.string,
  }),
  getFabrics: PropTypes.shape({
    getFabrics: PropTypes.func,
  }),
  filterState: PropTypes.shape({
    roomFilter: PropTypes.string,
    materialFilter: PropTypes.string,
    colorFilters: PropTypes.object,
    isFiltered: PropTypes.bool,
    isMaterialOptionFiltered: PropTypes.bool,
    isProductIdFiltered: PropTypes.shape({
      isFiltered: PropTypes.bool,
    }),
  }),
  actions: PropTypes.shape({
    onSearchStateChange: PropTypes.func,
    onLoadMoreResults: PropTypes.func,
  }),
  filterActions: PropTypes.shape({
    onProductIdFilterChange: PropTypes.func,
    onMaterialFilterChange: PropTypes.func,
    onColorFilterChange: PropTypes.func,
    onRoomFilterChange: PropTypes.func,
    onClearFilters: PropTypes.func,
  }),
  LUXContext: PropTypes.object,
};

export default compose(
  withRouter,
  withSearchState,
  withApolloSuspenseQuery(GET_FABRIC_DATA, {
    name: 'getFabrics',
    options: () => ({ variables: {} }),
  })
)(InspirationPhotoGrid);
